/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PermessiMieiDTO } from '../model/models';
import { Permesso } from '../model/models';
import { PermessoConcessoForm } from '../model/models';
import { PermessoUtenteDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetPermessiUtenteRequestParams {
    userId: string;
}

export interface SetPermessoUtenteRequestParams {
    userId: string;
    permesso: Permesso;
    permessoConcessoForm: PermessoConcessoForm;
}


export interface PermessiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Permessi extra effettivi del chiamante.
     * I ruoli arrivano alla dashboard dal token, i permessi no: vivono solo a DB.
     * @endpoint get /api/v1/gestione/permessi/me
*/
    getPermessiMiei(extraHttpRequestParams?: any): Observable<PermessiMieiDTO>;

    /**
     * Permessi extra assegnabili a un utente, con il loro stato (SUPERADMIN).
     * Contiene solo i permessi ammessi per i ruoli dell\&#39;utente.
     * @endpoint get /api/v1/gestione/permessi/utenti/{user_id}
* @param requestParameters
     */
    getPermessiUtente(requestParameters: GetPermessiUtenteRequestParams, extraHttpRequestParams?: any): Observable<Array<PermessoUtenteDTO>>;

    /**
     * Concede o revoca un permesso extra a un utente (SUPERADMIN).
     * Idempotente. La concessione richiede un ruolo a cui il permesso si applica (422); la revoca e\&#39; sempre ammessa. Effetto dalla richiesta successiva dell\&#39;utente.
     * @endpoint put /api/v1/gestione/permessi/utenti/{user_id}/{permesso}
* @param requestParameters
     */
    setPermessoUtente(requestParameters: SetPermessoUtenteRequestParams, extraHttpRequestParams?: any): Observable<Array<PermessoUtenteDTO>>;

}
